import { render, staticRenderFns } from "./PagamentoPix.vue?vue&type=template&id=2cc2f91a&"
import script from "./PagamentoPix.vue?vue&type=script&lang=js&"
export * from "./PagamentoPix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports